import React from "react";

export const normalizeRating = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(Math.min(5, n) * 10) / 10;
};

export const isDirectionsUrl = (value) => {
  if (typeof value !== "string") return false;
  const url = value.trim();
  if (!url || url === "null" || url === "undefined") return false;
  return url.startsWith("https://");
};

/** Online-booking slot dates are DD-MM-YYYY, times are HH:mm. */
export const parseBookingSlotDate = (date, timeSlot) => {
  const raw = String(date || "").trim();
  const m = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!m) return null;
  const [, dd, mm, yyyy] = m;
  const time = String(timeSlot || "").trim();
  return {
    date: `${yyyy}-${mm}-${dd}`,
    time,
    label: time ? `${raw} ${time}` : raw,
  };
};

export const calendarFields = (calendar) => {
  if (!calendar || typeof calendar !== "object") return null;
  if (!calendar.googleCalendarUrl && !calendar.displayDate && !calendar.displayTime) return null;
  return calendar;
};

export const ViewDirections = ({ url, className = "" }) => {
  if (!isDirectionsUrl(url)) return null;
  return (
    <a
      href={url.trim()}
      target="_blank"
      rel="noopener noreferrer"
      className={className || "inline-flex items-center justify-center px-4 py-2 rounded-lg border border-primary text-primary text-sm font-semibold"}
    >
      View Directions
    </a>
  );
};

export const AddToCalendar = ({ calendar, className = "" }) => {
  const cal = calendarFields(calendar);
  if (!cal?.googleCalendarUrl) return null;
  return (
    <a
      href={cal.googleCalendarUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className || "inline-flex items-center justify-center px-4 py-2 rounded-lg bg-primary text-white text-sm font-semibold"}
    >
      Add to Calendar
    </a>
  );
};

export const CalendarWhen = ({ calendar }) => {
  const cal = calendarFields(calendar);
  if (!cal?.displayDate && !cal?.displayTime) return null;
  return (
    <p className="text-sm text-on-surface-variant">
      {[cal.displayDate, cal.displayTime].filter(Boolean).join(" · ")}
    </p>
  );
};

const directionsOk = isDirectionsUrl("https://maps.google.com");
const directionsBad = isDirectionsUrl("null") || isDirectionsUrl("http://maps.google.com") || isDirectionsUrl("");
const slot = parseBookingSlotDate("12-10-2026", "10:00");
if (!directionsOk || directionsBad || normalizeRating(null) !== 0 || normalizeRating(4.26) !== 4.3) {
  throw new Error("bookingModels rating/url check failed");
}
if (!slot || slot.date !== "2026-10-12" || slot.time !== "10:00") {
  throw new Error("bookingModels slot parser failed");
}
